import { IContainer, ILazyBinder, injectContainer } from './container';
import type { IProgressPromise } from './promise';

export interface IFetchHeader {
    name: string;
    value: string;
}

export type Method = 'HEAD' | 'GET' | 'PUT' | 'PATCH' | 'POST' | 'DELETE' | 'OPTIONS';
export type ResponseTypes = 'json' | 'text' | 'blob' | 'arraybuffer' | 'void' | 'opaque';

export interface IFetchRequest {
    url: string;
    method?: Method;
    headers?: Array<IFetchHeader>;
    body?: string;
    expectedResponseType?: ResponseTypes;
    expectedResponseSize?: number;
}

export interface IFetchResponse<T> {
    request: IFetchRequest;
    statusCode: number;
    isStatusOk: boolean;
    error?: Error;
    payload: T | null;
}

/**
 * IFetcher external resource resolver
 *
 * @param {string} requestPayload - Request payload contains url, method?, headers?, body? etc
 * @param {string} [timeout] - Time to wait before giving up (Milliseconds)
 * @param {string} [retryCount] - A optional string param
 * @return {IProgressPromise<IFetchResponse<T>>} Promise with resource response
 */
export type IFetcher = <T>(
    requestPayload: IFetchRequest,
    timeout?: number,
    retryCount?: number,
) => IProgressPromise<IFetchResponse<T>>;

const TYPES = {
    IFetch: Symbol.for('IFetch'),
};

export function injectFetch(container: IContainer = injectContainer()): Promise<IFetcher> {
    return container.get<ILazyBinder<IFetcher>>(TYPES.IFetch)();
}

export function bindFetch(val: ILazyBinder<IFetcher>, container: IContainer = injectContainer()) {
    return container.bind<ILazyBinder<IFetcher>>(TYPES.IFetch, val);
}
